<template>
  <div class="challenges-analytics">
    <div class="statistical-data">
      <el-row :gutter="15">
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('challengeAnalysics.joinedCount') }}
            </div>
            <div class="statistics">
              {{ data.joined_count }}
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('challengeAnalysics.activeCount') }}
            </div>
            <div class="statistics">
              {{ data.active_count }}
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('challengeAnalysics.completedCount') }}
            </div>
            <div class="statistics">
              {{ data.completed_count }}
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('challengeAnalysics.incompleteCount') }}
            </div>
            <div class="statistics">
              {{ data.incomplete_count }}
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <div slot="header">
              {{ $t('challengeAnalysics.winnersCount') }}
            </div>
            <div class="statistics">
              {{ data.winners_count }}
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class challengeAnalysics extends Vue {
  data = {}

  async mounted() {
    const data = await this.$request.get(`/walk/challenges/${this.$route.params.id}/analytics`);
    this.data = data;
  }
}
</script>

<style lang="scss">
  .challenges-analytics {
    .el-row {
      margin-bottom: 20px;
    }

    .el-card {
      .el-card__header {
        padding: 10px;
        font-size: 14px;
        color: #909399;
        text-align: center;
        font-weight: bold;
      }

      .statistics {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
      }
    }
  }
</style>
